import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { emailService } from '../services/emailService';

/**
 * Async thunk to fetch emails from backend
 */
export const fetchEmails = createAsyncThunk(
  'emails/fetchEmails',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await emailService.listEmails(params);
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch emails');
    }
  }
);

/**
 * Async thunk to fetch filtered emails by sender list and/or date
 */
export const fetchEmailsFiltered = createAsyncThunk(
  'emails/fetchEmailsFiltered',
  async ({ fromList, date }, { rejectWithValue }) => {
    try {
      const params = {};
      if (fromList && fromList.length > 0) {
        params.fromList = fromList.join(',');
      }
      if (date) {
        params.date = date;
      }
      const response = await emailService.listEmailsFiltered(params);
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch filtered emails');
    }
  }
);

const initialState = {
  emails: [],
  filteredEmails: [],
  loading: false,
  error: null,
};

const emailSlice = createSlice({
  name: 'emails',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearEmails: (state) => {
      state.emails = [];
      state.filteredEmails = [];
    },
  },
  extraReducers: (builder) => {
    // Fetch emails
    builder
      .addCase(fetchEmails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmails.fulfilled, (state, action) => {
        state.loading = false;
        state.emails = action.payload;
      })
      .addCase(fetchEmails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch emails';
      });

    // Fetch filtered emails
    builder
      .addCase(fetchEmailsFiltered.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmailsFiltered.fulfilled, (state, action) => {
        state.loading = false;
        state.filteredEmails = action.payload;
      })
      .addCase(fetchEmailsFiltered.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch filtered emails';
      });
  },
});

export const { clearError, clearEmails } = emailSlice.actions;
export default emailSlice.reducer;